/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_Q3Inputs */

const en_to_csv_faq_q3 = /** @type {(inputs: To_Csv_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if objects have different keys?`)
};

const ko_to_csv_faq_q3 = /** @type {(inputs: To_Csv_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`객체마다 키가 다르면 어떻게 되나요?`)
};

const ja_to_csv_faq_q3 = /** @type {(inputs: To_Csv_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オブジェクトのキーが異なる場合はどうなりますか？`)
};

/**
* | output |
* | --- |
* | "What if objects have different keys?" |
*
* @param {To_Csv_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_q3 = /** @type {((inputs?: To_Csv_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_q3(inputs)
	if (locale === "ko") return ko_to_csv_faq_q3(inputs)
	return ja_to_csv_faq_q3(inputs)
});